'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _uiBlock = require('./directives/uiBlock');

var _uiBlock2 = _interopRequireDefault(_uiBlock);

var _spinner = require('./directives/spinner/spinner');

var _spinner2 = _interopRequireDefault(_spinner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _module = _angular2.default.module('angularUiBlock', []);

_module.directive('spinner', _spinner2.default).directive('uiBlock', _uiBlock2.default);

exports.default = _module.name;


//////////////////
// WEBPACK FOOTER
// /app/~/angular-ui-block/lib/index.js
// module id = 2583
// module chunks = 38